import $ from 'jquery';
import jqueryNiceScroll from 'jquery-nicescroll';
import Backbone from 'backbone';
import Global from 'models/Global';
import NotificationView from 'views/NotificationView';
var NotificationsView = Backbone.View.extend({

    events: {},

    initialize: function() {
        this.listenTo(this.model, 'add', this.addNotification);
        this.listenTo(this.model, 'sync', this.setEmptyState);
        this.subViews = {};
    },

    setEmptyState: function() {
        if (this.model.models.length > 0) {
            this.$('.notifications-message-empty-text').addClass('hide');
        }
    },

    addNotification: function(msg) {
        var notificationView = new NotificationView({
            model: msg
        });
        this.subViews[msg.get('id')] = notificationView;
        notificationView.render().$el.prependTo(this.$el);
    }
});

export default NotificationsView;

